import { useEffect, useState } from "react";
import api from "@/lib/api";

export function AuthImage({ mediaId, variant = "thumbnail", alt = "", className, onClick, style, dataTestid }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!mediaId) return undefined;
    let active = true;
    let objectUrl;
    const endpoint = variant === "full" ? "download" : "thumbnail";
    api.get(`/media/${mediaId}/${endpoint}`, { responseType: "blob" })
      .then((res) => { if (!active) return; objectUrl = URL.createObjectURL(res.data); setSrc(objectUrl); })
      .catch(() => {});
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [mediaId, variant]);
  return <img src={src || undefined} alt={alt} className={className} style={style} onClick={onClick} data-testid={dataTestid} />;
}
